import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import InputTextArea from "./InputTextArea";
import { Divider } from "primereact/divider";
import LocalDelimitationNational from "./LocalDelimitationNational";
import { changeLang } from "./Language/ChangeLang";
import { DermacationLevels } from "../constants";
import { AppDB } from "../App";
import { useContext } from "react";

const AddDermacation = ({
	onSave = () => {},
	editMode = false,
	setDialogVisible,
	showDialog = false,
	setdermacationForm,
	dermacationForm,
	setNodeName,
	nodeName,
	selectedEvent,
	isNational
}) => {
	var raw = {
		districts: [],
		districtID: null,
		districtName: null,
		councils: [],
		councilID: null,
		councilName: null,
		votingDistricts: [],
		votingDistrictID: null,
		votingDistrictName: null,
		votingStations: [],
		votingStationID: null,
		votingStationName: null,
		villages: [],
		villageID: null,
		villageName: null,
		level: null,
		delimitationID: null
	};

	const [localDelimitation, setLocalDelimitation] = useState({});
	const [updatedRegCentre, setUpdatedRegCentre] = useState(false);
	const [initialForm, setInitialForm] = useState(null);
	const [villageDialogVisible, setVillageDialogVisible] = useState(false);
	const villageNationalTree = dermacationForm?.VillageNode?.data?.registrationCentreModel;
	const villageLocalTree = dermacationForm?.VillageNode?.data?.localRegistrationCentreModel;
	const rawForm = {
		name: "",
		DelimitationNo: null,
		code: "",
		description: ""
	};

	const isEditingVillage = editMode && dermacationForm?.DelimitationLevelID === DermacationLevels?.Level5;

	if (!dermacationForm) return null;
	const extractVotingDistrictPrefix = () => dermacationForm?.code?.match(/\d+/)?.[0] ?? "";

	const extractRegistrationCentrePrefix = () => dermacationForm?.registrationCentreName?.match(/\d+/)?.[0] ?? "";
	const canEditRC =
		dermacationForm.DelimitationLevelID === DermacationLevels?.Level4 &&
		dermacationForm.districtID &&
		dermacationForm.constituencyID &&
		dermacationForm.votingDistrictID;

	const canEditVillage =
		editMode ||
		(dermacationForm.DelimitationLevelID === DermacationLevels?.Level5 &&
			dermacationForm.registrationCentreID &&
			dermacationForm.districtID &&
			dermacationForm.constituencyID &&
			dermacationForm.votingDistrictID);

	const removeDigitCode = (value = "") => {
		return value.replace(/^\s*\d+\s*-\s*/, "");
	};

	const currentSnapshot = {
		name: removeDigitCode(dermacationForm?.name || "").trim(),
		DelimitationNo: String(dermacationForm?.DelimitationNo ?? null).trim(),
		code: String(dermacationForm?.code ?? "").trim(),
		description: String(dermacationForm?.description ?? "").trim(),
		registrationCenterNAID: dermacationForm?.registrationCenterNAID ?? null,
		registrationCenterLGID: dermacationForm?.registrationCenterLGID ?? null
	};

	const hasChanges = !editMode || !initialForm || JSON.stringify(currentSnapshot) !== JSON.stringify(initialForm);

	return (
		<>
			<Dialog
				header={editMode ? "Update Demarcation" : "Add Demarcation"}
				visible={showDialog}
				style={{ width: "80vw", height: "95vh" }}
				onHide={() => setDialogVisible(false)}
				footer={
					<div className="flex justify-content-end gap-2">
						<Button label="Cancel" icon="pi pi-times" text onClick={() => setDialogVisible(false)} />
						<Button
							className="p-button-success"
							label={editMode ? "Update" : "Add"}
							icon="pi pi-check"
							onClick={() => {
								if (editMode && !hasChanges) return;
								onSave(dermacationForm);
							}}
							disabled={
								(dermacationForm.DelimitationLevelID === DermacationLevels?.Level4 && !canEditRC) ||
								(dermacationForm.DelimitationLevelID === DermacationLevels?.Level5 && !canEditVillage)
							}
						/>
					</div>
				}
				className="py-4"
			>
				<div className="p-fluid py-4 card mt-4">
					<Divider>
						<h3>Demarcation Details</h3>
					</Divider>

					<div className="grid mb-3">
						{/* District */}
						<div className="col-12 lg:col-6">
							<label>
								{isNational
									? changeLang.get("national_delimitation.level1District")
									: changeLang.get("local_delimitation.level1District")}
							</label>
							<InputText value={dermacationForm.districtName || ""} disabled />
						</div>

						{/* Constituency */}
						<div className="col-12 lg:col-6">
							<label>
								{isNational
									? changeLang.get("national_delimitation.level2ConstituencyCouncil")
									: changeLang.get("local_delimitation.level2ConstituencyCouncil")}
							</label>
							<InputText value={dermacationForm.constituencyName || ""} disabled />
						</div>

						{/* Voting District */}
						<div className="col-12 lg:col-6">
							<label>
								{isNational
									? changeLang.get("national_delimitation.level3PollingElectorDivision")
									: changeLang.get("local_delimitation.level3PollingElectorDivision")}
							</label>
							<InputText value={dermacationForm.votingDistrictName || ""} disabled />
						</div>
						{dermacationForm.DelimitationLevelID === DermacationLevels?.Level5 && (
							<div className="col-12 lg:col-6">
								<label>
									{isNational ? "Voting Centre " : "Polling Centre "} Name <span className="text-error">*</span>
								</label>
								<InputText
									value={dermacationForm?.registrationCentreName || ""}
									placeholder={isNational ? "Enter VC Name" : "Enter PC Name "}
									disabled
								/>
							</div>
						)}
						{/* {((editMode && dermacationForm?.DelimitationLevelID === DermacationLevels?.Level5) || !!localDelimitation?.votingStationName) && ( */}
						{editMode && dermacationForm?.DelimitationLevelID === DermacationLevels?.Level5 && (
							<div className="card col-12 mx-2">
								{/* <h5 style={{background:"#c3c3c3"}}>{isNational ? "National Structure " : " "}</h5> */}
								<div className="grid mb-3">
									<div className="col-12 lg:col-6">
										<label>
											{isNational
												? changeLang.get("national_delimitation.level1District")
												: changeLang.get("local_delimitation.level1District")}
										</label>
										<div className="p-inputtext p-component p-filled p-disabled">
											{!isNational
												? villageNationalTree?.pollingDivisionModel?.constituencyModel?.districtModel?.code +
													"-" +
													villageNationalTree?.pollingDivisionModel?.constituencyModel?.districtModel?.name
												: villageLocalTree?.electorDivisionModel?.councilModel?.localDistrictModel?.code +
													"-" +
													villageLocalTree?.electorDivisionModel?.councilModel?.localDistrictModel?.name}
										</div>
									</div>
									<div className="col-12 lg:col-6">
										<label>
											{isNational
												? changeLang.get("local_delimitation.level2ConstituencyCouncil")
												: changeLang.get("national_delimitation.level2ConstituencyCouncil")}
										</label>
										<div className="p-inputtext p-component p-filled p-disabled">
											{/* {isNational ? secondaryDermacationDetails?.councilName : localDelimitation?.councilName} */}
											{!isNational
												? villageNationalTree?.pollingDivisionModel?.constituencyModel?.code +
													"-" +
													villageNationalTree?.pollingDivisionModel?.constituencyModel?.name
												: villageLocalTree?.electorDivisionModel?.councilModel?.code +
													"-" +
													villageLocalTree?.electorDivisionModel?.councilModel?.name}
										</div>
									</div>
									<div className="col-12 lg:col-6">
										<label>
											{isNational
												? changeLang.get("local_delimitation.level3PollingElectorDivision")
												: changeLang.get("national_delimitation.level3PollingElectorDivision")}
										</label>
										<div className="p-inputtext p-component p-filled p-disabled">
											{/* {isNational ? secondaryDermacationDetails?.votingDistrictName : localDelimitation?.councilName} */}

											{!isNational
												? villageNationalTree?.pollingDivisionModel?.code +
													"-" +
													villageNationalTree?.pollingDivisionModel?.name
												: villageLocalTree?.electorDivisionModel?.code + "-" + villageLocalTree?.electorDivisionModel?.name}
										</div>
									</div>
									{dermacationForm?.DelimitationLevelID > DermacationLevels?.Level4 && (
										<div className="col-12 lg:col-6">
											<label>
												{isNational
													? changeLang.get("local_delimitation.level4RegistrationCentre")
													: changeLang.get("national_delimitation.level4RegistrationCentre")}
											</label>
											<div className="p-inputtext p-component p-filled p-disabled">
												{/* {editMode ? secondaryDermacationDetails?.votingStationName : localDelimitation?.votingStationName} */}
												{!isNational
													? villageNationalTree?.code + "-" + villageNationalTree?.name
													: villageLocalTree?.code + "-" + villageLocalTree?.name}
											</div>
										</div>
									)}
								</div>
							</div>
						)}
						{/* Registration Centre */}
						{dermacationForm.DelimitationLevelID === 4 && (
							<div className="card col-12 px-2 mx-2">
								<div className="grid mb-3">
									<div className="col-12 lg:col-6">
										<label>{isNational ? "Voting Centre " : "Polling Centre "} Name</label>
										<InputText
											value={removeDigitCode(dermacationForm.name) || ""}
											placeholder={isNational ? "Enter Voting Centre Name " : "Enter Polling Centre Name "}
											disabled={!canEditRC}
											onChange={(e) => {
												const value = e.target.value.toUpperCase();
												setNodeName(value);
												setdermacationForm((prev) => ({
													...prev,
													name: value
												}));
											}}
										/>
									</div>
									<div className="col-12 lg:col-6">
										<label>
											{isNational ? "Enter Voting Centre " : "Enter Polling Centre "} Number{" "}
											<span className="text-error">*</span>
										</label>
										<InputText
											value={isNational ? dermacationForm.DelimitationNo : dermacationForm.DelimitationNo}
											placeholder={isNational ? " Enter Voting Centre Number " : "Enter Polling Centre Number "}
											disabled={!canEditRC}
											onChange={(e) => {
												let num = e.target.value.trim();

												num = num.replace(/^0+/, "");

												// Add leading zero if single digit (1-9)
												if (/^[1-9]$/.test(num)) {
													num = `0${num}`;
												}

												const finalCode = `${dermacationForm.parentCode || ""}${num}`;
												isNational
													? setdermacationForm((prev) => ({
															...prev,
															DelimitationNo: Number(num),
															code: finalCode
														}))
													: setdermacationForm((prev) => ({
															...prev,
															DelimitationNo: Number(num),
															code: finalCode
														}));
											}}
										/>
									</div>
									<div className="col-12 lg:col-6">
										<label>Code</label>
										<InputText value={dermacationForm.code || ""} disabled />
									</div>
								</div>
							</div>
						)}

						{/* Village */}
						{dermacationForm.DelimitationLevelID === DermacationLevels?.Level5 && (
							<>
								{!editMode && (
									<div className="col-12 lg:col-6">
										<label>
											{isNational ? "Select Polling Centre" : "Select Voting Centre "}
											<span className="text-error">*</span>
										</label>
										<Button
											value={dermacationForm.villageName || ""}
											placeholder="Enter Village Name"
											onClick={() => {
												setVillageDialogVisible(true);
											}}
											label={
												editMode
													? isNational
														? "Update Polling Centre "
														: "Update Voting Centre"
													: isNational
														? "Add  Polling Centre"
														: "Add Voting Centre"
											}
											className="p-button-success"
											icon="pi pi-plus"
										/>
									</div>
								)}
								<div className="col-12 lg:col-6">
									<label>
										Village Name <span className="text-error">*</span>
									</label>
									<InputText
										value={removeDigitCode(dermacationForm.villageName) || ""}
										placeholder="Enter Village Name"
										onChange={(e) => {
											const value = e.target.value.toUpperCase();
											// setNodeName(value);
											// setNodeName(value);
											setdermacationForm((prev) => ({
												...prev,
												villageName: value
											}));
										}}
									/>
								</div>
								{editMode && (
									<>
										<div className="col-12 lg:col-6">
											<label>
												Village Number <span className="text-error">*</span>
											</label>
											<InputText
												disabled
												value={dermacationForm.DelimitationNo ?? ""}
												placeholder="Enter Village Number"
												onChange={(e) => {
													let num = e.target.value.trim();

													num = num.replace(/^0+/, "");

													if (!/^\d*$/.test(num)) return;

													if (num.length === 1) {
														num = `0${num}`;
													}

													const finalCode = isNational
														? `${dermacationForm.parentCode || ""}${num}`
														: `${dermacationForm.registrationCenterNAID || ""}${num}`;

													setdermacationForm((prev) => ({
														...prev,
														DelimitationNo: num === "" ? "" : Number(num),
														code: finalCode
													}));
												}}
											/>
										</div>

										<div className="col-12 ">
											<label>Code</label>
											<InputText value={dermacationForm?.code} disabled />
										</div>
									</>
								)}
							</>
						)}

						<div className="col-12">
							<label>Description</label>
							<InputTextArea
								value={dermacationForm.description || ""}
								placeholder=""
								onChange={(e) =>
									setdermacationForm((prev) => ({
										...prev,
										description: e.target.value.toUpperCase()
									}))
								}
							/>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				header={isNational ? "Select Polling Centre" : "Select Voting Centre"}
				visible={villageDialogVisible}
				style={{ width: "70vw", height: "80vh" }}
				onHide={() => setVillageDialogVisible(false)}
			>
				<LocalDelimitationNational
					showVillage={false}
					setLocalDelimitation={setLocalDelimitation}
					isNational={!isNational}
					isDermacationManagement={true}
					onChange={(delimitationID, level, data) => {
						if (!data) return;

						// Always update the IDs (your existing flow)
						setdermacationForm((prev) => ({
							...prev,
							...(isNational ? { registrationCenterLGID: delimitationID } : { registrationCenterNAID: delimitationID }),
							delimitationLevelID: level
						}));

						// ✅ We only override when editing a village and user selected a NEW parent (level 4)
						if (level === DermacationLevels.Level4) {
							const pickedParentModel = data?.registrationCentreModel ?? data?.RegistrationCentreModel ?? data;

							setdermacationForm((prev) => ({
								...prev,
								RegistrationCentreModel: pickedParentModel,
								registrationCentreName: data?.name ?? prev.registrationCentreName,
								...(isNational ? { registrationCenterLGID: delimitationID } : { registrationCenterNAID: delimitationID }),
								delimitationLevelID: level
							}));

							if (isEditingVillage) {
								setUpdatedRegCentre(true);
							}

							setVillageDialogVisible(false);
							return;
						}

						// Normal close for other flows
						if (level === DermacationLevels.Level4) {
							setVillageDialogVisible(false);
						}
					}}
				/>
			</Dialog>
		</>
	);
};

export default AddDermacation;
